import Constants from "../../constants/Constants";
import axios from "../axios";
// import { checkToken } from "../utils/Utils";
import authHeader from "./auth-header";
const AccountService = {
    fetchAccount: async (accountId, auth) => {
        let url = Constants.LOGIN.INITIATE;
        let req = await axios.get(url, {
            headers: {
                Authorization: `${auth}`
            }
        });
        if (req.data) {
            let { type, data } = req.data;
            console.log(type)
        }
        return req.data;
    },
    fetchAllAccounts: async (auth) => {
        console.log(auth);
        let url = Constants.ACCOUNTS.ALL;
        let req = await axios.get(url, {
            headers: {
                Authorization: `${auth}`
            }
        });
        if (req.data) {
            let { type, data } = req.data;
            console.log(type)
        }
        return req.data;
    },
    newAccount: async (data) => {
        let url = Constants.ACCOUNTS.NEW;
        console.log(authHeader())
        let req = await axios.post(url, data, {
            headers: {
                Authorization: `${authHeader()}`
            }
        });
        if (req.data) {
            let { type, data } = req.data;
            console.log(data)
        }
        return req.data;
    },
    updateAccount: async (data) => {
        let url = Constants.ACCOUNTS.UPDATE;
        console.log(url)
        let req = await axios.post(url, data, {
            headers: {
                Authorization: `${authHeader()}`
            }
        })

        if (req.data) {
            let { type, data } = req.data;
            console.log(data);
        }
        return req.data;
    }
};

export default AccountService;
